/**
 * Links out to the Facilon marketing site and the company's social accounts.
 *
 * Company pages (About Us / Our Team / Our Expertise / FAQs) deliberately stay on the
 * marketing site rather than being rebuilt here: Laravel forked Our Team and the fork
 * went stale (it still lists someone who has left and misses two current people), so a
 * second copy in this app would rot the same way. Legal documents are the opposite case
 * and are served from our own routes, because they are what registration consents point at.
 *
 * Every URL here was verified to return 200 on 2026-09-12. Note the marketing site's own
 * footer links FAQs at /our-team — that is a bug on their side; /faq is the real page.
 */
export const FACILON_SITE = 'https://facilonservices.co.in';

export const SITE_LINKS = {
  aboutUs: `${FACILON_SITE}/about-us`,
  ourTeam: `${FACILON_SITE}/our-team`,
  ourExpertise: `${FACILON_SITE}/our-expertise`,
  faqs: `${FACILON_SITE}/faq`,
  /** The site's "Contact Us" is its expression-of-interest form; it has no /contact-us page. */
  contactUs: `${FACILON_SITE}/expression-of-interest`,
} as const;

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/facilonServices/',
  instagram: 'https://www.instagram.com/facilonservices',
  linkedin: 'https://www.linkedin.com/company/facilon-services/about/',
  x: 'https://twitter.com/facilonservices',
} as const;

export const CONTACT_EMAIL = 'reachus@facilonservices.com';

/** Spread onto every outbound <a> so a half-finished form is never replaced by the new page. */
export const EXTERNAL_LINK_PROPS = {
  target: '_blank',
  rel: 'noopener noreferrer',
} as const;
